import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaSearch, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BiSolidEdit } from "react-icons/bi";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const User = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dltContent, setDltContent] = useState({ dltId: "", dltName: "" });
  const [dltLoading, setDltLoading] = useState(false);

  useEffect(() => {
    getAllUsers();
  }, []);

  const getAllUsers = async () => {
    try {
      const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/users/get-all-users`,
        headers: {},
        data: "",
      };

      const response = await axios.request(config);
      setUsers(response?.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter((user) => {
    const name = user?.name || "";
    const phone = user?.phoneNumber || "";
    const email = user?.email || "";
    return (
      name.toLowerCase().includes(search.toLowerCase()) ||
      phone.includes(search) ||
      email.toLowerCase().includes(search.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const totalItems = filteredUsers.length;

  // Get current page items
  const currentItems = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  console.log("users", currentItems);

  return (
    <div className="mt-6 mb-12 px-6">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-xl font-extrabold text-primaryText">
          Manage Users
        </h1>
      </div>

      {/* Search Filter */}
      <div className="mb-4 rounded-lg bg-white p-4 shadow-md">
        <div className="flex flex-col justify-center md:flex-row md:justify-between">
          {/* Search Input */}
          <div className="w-full md:w-1/3">
            <label className="text-md mb-1 block font-medium tracking-normal text-gray-600">
              Search
            </label>
            <div className="relative">
              <input
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1); // Reset to first page when searching
                }}
                placeholder="Search users by name, phone or email"
                className="w-full rounded-md border px-4 py-2 focus:ring focus:ring-primary"
              />
              <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 transform text-gray-400" />
            </div>
          </div>
        </div>
      </div>

      {/* Users Table */}
      <div className="overflow-x-auto rounded-lg bg-white text-sm tracking-wide shadow-md">
        <table className="w-full table-auto text-left">
          <thead>
            <tr className="bg-gray-100 text-sm uppercase text-primary">
              <th className="px-4 py-2">Sl</th>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Phone</th>
              <th className="px-4 py-2">Email</th>
              <th className="px-4 py-2">User Type</th>
              <th className="px-4 py-2">Gender</th>
              {/* <th className="px-4 py-2">Actions</th> */}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              [...Array(itemsPerPage)].map((_, index) => (
                <tr key={index} className="animate-pulse border-t">
                  <td className="px-4 py-4">
                    <div className="h-4 w-8 rounded bg-gray-300"></div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 w-32 rounded bg-gray-300"></div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 w-24 rounded bg-gray-300"></div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 w-40 rounded bg-gray-300"></div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 w-20 rounded bg-gray-300"></div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 w-16 rounded bg-gray-300"></div>
                  </td>
                  {/* <td className="px-4 py-4">
                    <div className="h-6 w-6 rounded bg-gray-300"></div>
                  </td> */}
                </tr>
              ))
            ) : currentItems.length > 0 ? (
              currentItems.map((user, i) => (
                <tr
                  key={user?._id}
                  className="border-t transition duration-100 hover:bg-[#fbeeee]"
                  // onClick={() => navigate(`/admin/user-details/${user?._id}`)}
                >
                  <td className="cursor-pointer px-4 py-4">
                    {(currentPage - 1) * itemsPerPage + i + 1}
                  </td>
                  <td className="cursor-pointer px-4 py-4 capitalize">
                    <div className="flex items-center gap-3">
                      <span>{user?.name}</span>
                    </div>
                  </td>

                  <td className="cursor-pointer px-4 py-4">
                    {user?.phoneNumber || "N/A"}
                  </td>
                  <td className="cursor-pointer px-4 py-4">
                    {user?.email || "N/A"}
                  </td>
                  <td className="cursor-pointer px-4 py-4 capitalize">
                    {user?.userType || "N/A"}
                  </td>
                  <td className="cursor-pointer px-4 py-4 capitalize">
                    {user?.gender || "N/A"}
                  </td>
                  {/* <td className="px-4 py-4">
                    <button className="text-blue-600">
                      <BiSolidEdit size={20} />
                    </button>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="px-4 py-4 text-center text-gray-500">
                  {search
                    ? `No users found matching "${search}"`
                    : "No users found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="mt-6 flex justify-center">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Stack>
        </div>
      )}
    </div>
  );
};

export default User;
